// components
import LoginOverlay from "../../components/LoginOverlay";
import LoginForm from "./LoginForm";

export default function Login() {
  return (
    <LoginOverlay
      backgroundImageClass="hotel-panel-login-page"
      header="Login"
      subtitle="Hotel Panel"
      form={<LoginForm />}
    />
  );
}
